import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from 'utils/utils'
import { Row } from 'antd'
import 'styles/ChecRow.css'

const ChecRow = ({
  children,
  align,
  gutter,
  justify,
  className,
  style,
  type,
}) => (
  <Row
    align={align}
    gutter={gutter}
    justify={justify}
    type="flex"
    className={classNames('chec-row', type, className)}
    style={style}
  >
    {children}
  </Row>
)

ChecRow.defaultProps = {
  align: 'middle',
  gutter: { xs: 12, sm: 12 },
  justify: 'start',
  children: [],
  style: { marginLeft: '6px', marginRight: '6px' },
  type: 'full',
}

ChecRow.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  align: PropTypes.oneOf(['top', 'middle', 'bottom']),
  gutter: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  justify: PropTypes.oneOf([
    'start',
    'end',
    'center',
    'space-around',
    'space-between',
  ]),
  className: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.oneOf(['full', 'inline']),
}

export default ChecRow
